import {FullScreenLoader} from "@/components/loader/FullScreenLoader.tsx";
import {getProfileWishes} from "@/api/apiMethods.ts";
import {AuthProfile} from "@/api/types.ts";
import {useAuthProfile} from "@/providers/AuthProfileProvider.tsx";
import {useEffect, useState} from "react";
import {Outlet, useOutletContext, useParams} from "react-router-dom";
import {WishOutletContext} from "@/pages/layout/WishOutletContext.ts";

export const GiftedWishLayout = () => {
  const {wishId} = useParams();
  const parentContext = useOutletContext<WishOutletContext>();
  const [wish, setWish] = useState<WishOutletContext["wish"]>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadFinished, setIsLoadFinished] = useState<boolean>(false);

  let profileFromContext: AuthProfile | undefined = parentContext.authProfile;
  try {
    const {authProfile} = useAuthProfile();
    profileFromContext = authProfile || profileFromContext;
  } catch {
    profileFromContext = parentContext.authProfile;
  }

  useEffect(() => {
    const contextWish = profileFromContext?.allWishes.find(wish => wish.id === wishId);
    if (contextWish) {
      setWish(contextWish);
      setIsLoadFinished(true);
      setIsLoading(false);
      return;
    }

    if (!wishId || !profileFromContext?.user.id) {
      setIsLoadFinished(true);
      return;
    }

    setIsLoading(true);
    setIsLoadFinished(false);
    getProfileWishes(profileFromContext.user.id, {status: "gifted", sortBy: "giftedAt"})
      .then((wishes) => {
        setWish(wishes.find(wish => wish.id === wishId));
      })
      .catch(() => {
        setWish(undefined);
      })
      .finally(() => {
        setIsLoading(false);
        setIsLoadFinished(true);
      });
  }, [profileFromContext?.allWishes, profileFromContext?.user.id, wishId]);

  if (isLoading || !isLoadFinished) {
    return <FullScreenLoader/>;
  }

  return (
    <Outlet
      context={{
        ...parentContext,
        authProfile: profileFromContext,
        wish,
        setWish,
      }}
    />
  );
};
